import React from 'react';
import { Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';

export const getSpinner = (props: SpinProps) => {
  return <Spin {...props} />;
};
